<div class="sig-wrap">
  <div class="sig-modes">
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm sig-mode" [class.active]="mode === 'draw'" (click)="setMode('draw')">Draw</button>
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm sig-mode" [class.active]="mode === 'type'" (click)="setMode('type')">Type</button>
    <span class="sig-spacer"></span>
    <button type="button" class="br-btn br-btn--ghost br-btn--sm" (click)="clear()">Clear</button>
  </div>

  <div class="sig-type-row" *ngIf="mode === 'type'">
    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="sig-name">
      <mat-label>Type your name</mat-label>
      <input matInput [(ngModel)]="typedName" (ngModelChange)="renderTyped()" maxlength="60">
    </mat-form-field>
    <div class="sig-fonts">
      <button type="button" class="br-btn br-btn--outline-secondary sig-font" *ngFor="let f of fonts; let i = index"
              [class.active]="fontIdx === i" [style.font-family]="f.css" (click)="pickFont(i)">
        {{ f.label }}
      </button>
    </div>
  </div>

  <canvas #canvas width="560" height="160" class="sig-canvas"
          [class.drawable]="mode === 'draw'"
          (pointerdown)="onDown($event)" (pointermove)="onMove($event)"
          (pointerup)="onUp()" (pointerleave)="onUp()"></canvas>
  <div class="sig-baseline">Signature</div>
</div>
